<style lang="less" scoped>
@import url("../../../../stylesheet/variable.less");
.home-goods-topic {
  margin-bottom: 10px;
  color: rgb(25, 26, 27);
  position: relative;
  overflow: hidden;
  z-index: 1;
  .bg-img-class {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .topic-title {
    height: 52px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 4vw;
    font-size: 17px;
    div {
      z-index: 4;
    }
    .to-more-goods {
      font-size: 13px;
      color: #191A1B;
      img {
        width: 4px;
        display: inline-block;
        height: 8px;
        margin-left: 3px;
      }
    }
  }
  .topic-banner {
    padding: 0 1.33vw;
    width: 100%;
    height: 80px;
    .lazy-img {
      z-index: 4;
    }
  }
  .topic-goods {
    display: flex;
    flex-wrap: wrap;
    padding: 1.33vw 0 0px 1.33vw;
    .topic-goods-item {
      background: #fff;
      z-index: 4;
      /deep/ .target-img {
        border-bottom-left-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
      }
      br {
        display: none;
        @media only screen and (max-width: 320px){
          display: block;
        }
      }
      padding-bottom: 7px;
      margin-right: 1.34vw;
      margin-bottom: 5px;
      width: 29.7vw;
      .img-wrap {
        min-height: 50px;
        position: relative;
        margin-bottom: 8px;
        .rapidAfterSales-image{
          width: 7.2vw;
          position: absolute;
          right: 5px;
          top: 5px;
          z-index: 3;
        }
        .labels {
          position: absolute;
          bottom: 0;
          left: 0;
          .item-common-label {
            -webkit-text-size-adjust: none;
            margin-right: 5px;
            color: #fff;
            float: left;
            padding: 0 4px;
            font-size: 8px;
            height: 13px;
            line-height: 13px;
            border-radius: 1px;
          }
          .item-common-label:last-child {
            margin-right: 0px;
          }
        }
        .buyer-label {
          position: absolute;
          top: 5px;
          color: #bca27d;
          width: 16px;
          font-size: 9px;
          text-align: center;
          padding: 4px 2px;
          left: 5px;
          line-height: 11px;
          background-color: rgba(255, 255, 255, 0.8);
          &::before {
            .setBorderLineWithoutRadius(#bca27d);
          }
        }
      }
      .goods-master-name {
        margin-bottom: 3px;
        color: rgb(25, 26, 27);
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        word-break: break-all;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        span {
          vertical-align: middle;
          display: inline-block;
        }
        .country-image-label {
          width: 20px;
          height: 13px;
        }
        .video-box {
          display: inline-block;
          width: 20px;
          height: 13px;
          text-align: center;
          background-color: #c63036;
          .video-play {
            width: 0;
            height: 0;
            border-top: 4px solid transparent;
            border-left: 7px solid #ffffff;
            border-bottom: 4px solid transparent;
            display: inline-block;
          }
        }
      }
      .goods-price {
        .goods-master-price {
          display: inline-block;
        }
        .goods-market-price {
          display: inline-block;
          text-decoration: line-through;
        }
        .pintuan_img {
          width: 22px;
          height: 11px;
          margin-left: -3px;
        }
      }
    }
    .topic-goods-item:nth-child(3n) {
      margin-right: 0px;
    }
  }
}

</style>

<template>
  <div :class="['home-goods-topic border-radius-8']" :style="customStyle">
    <div class="bg-img-class" v-if="isShowBannerImgColor">
      <lazy-img :src="blurTopBanner" width="100%" height="100%"></lazy-img>
    </div>
    <div class="topic-title">
      <div>{{topicName}}</div>
      <div @click="toMore" class="to-more-goods">
        更多
        <img src="../../../../image/home/home-to-more.png">
      </div>
    </div>
    <div
      class="topic-banner"
      @click="bannerJump"
    >
      <lazy-img :src="topicBanner" width="100%" height="100%"></lazy-img>
    </div>
    <div class="topic-goods">
      <div
        class="topic-goods-item border-radius-8"
        v-for="(goods, index) in goodsFormat"
        :key="goods.productId"
        @click="toProductDetail(goods.href)"
      >
        <div
          class="img-wrap"
        >
          <img class="rapidAfterSales-image" :src="goods.rapidAfterSalesImage"/>

          <!-- isSold，判断库存是否为0 以此显示已售完的图片 -->
          <isSoldout
            :isSold="goods.totalInventory == 0"
            :src="goods.imgUrl"
            alt
            width="29.7vw"
            height="29.7vw"
          ></isSoldout>
          <span class="labels">
            <div
              class="item-common-label"
              v-for="(l,i) in goods.commonLabel"
              :style="`background-color:${l.labelColor}`"
              :key="i"
              v-if="i<2"
            >{{l.title}}</div>
          </span>
          <div
            class="buyer-label"
            v-if="goods.labels && goods.labels.buyerShow"
          >{{goods.labels.buyerShow}}</div>
        </div>
        <div class="goods-master-name padding-lr-5">
          <span v-if="goods.countryImage">
            <img class="country-image-label" :src="goods.countryImage">
          </span>
          <span v-if="goods.hasVideo == 1">
            <img class="country-image-label" src="../../../../image/buyer/iconPlay.png">
          </span>
          {{goods.masterName}}
        </div>
        <div class="goods-price padding-lr-5">
          <price
            :style="{marginRight: '2px'}"
            class="goods-master-price"
            :originPrice="goods.price"
            intSize="14"
            fracSize="9"
          ></price>
          <br v-if="!((!goods.groupPrice || goods.groupPrice == 0) && goods.marketPrice != 0 && goods.marketPrice > goods.price)">
          <price
            v-if="(!goods.groupPrice || goods.groupPrice == 0) && goods.marketPrice != 0 && goods.marketPrice > goods.price"
            class="goods-market-price"
            :originPrice="goods.marketPrice"
            intSize="11"
            fracSize="10"
            color="rgb(189, 192, 197)"
          ></price>
          <!-- 拼团价的显示 -->
          <price
            v-show="!!goods.groupPrice"
            class="goods-master-price"
            :originPrice="goods.groupPrice"
            intSize="12"
            fracSize="12"
          ></price>
          <!-- 拼团图片 -->
          <img v-show="!!goods.groupPrice" class="pintuan_img" src="../../../../image/global/pintuan.png" alt='拼团图片'>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import op from "object-path";
import { resolveActionPath, goodsListFormat } from "../../../util/function.js";
import price from "../../../components/price";
import icon from "../../../components/icon";
import lazyImg from "../../../components/lazy-img";
import isSoldout from "../../../components/isSoldOut";

export default {
  props: ["topic"],
  data() {
    return {
      isShowBannerImgColor: false, // 是否展示banner背景图片的颜色
    };
  },
  mounted() {
    // console.log('我要看的数据',op(this.topic).get("productList"))
  },
  computed: {
    topicName() {
      return op(this.topic).get("masterTitle") || "";
    },
    topicBanner() {
      return op(this.topic).get("banner.imgUrl") || "";
    },
    // 获取banner背景图 并模糊放大
    blurTopBanner() {
      const url = op(this.topic).get("banner.imgUrl") || ""
      
      return url + '?x-oss-process=image/resize,w_100/blur,s_50,r_50'
    },
    topicGoods() {
      return op(this.topic).get("productList");
    },
    goodsFormat() {
      return goodsListFormat(this.topicGoods)
    },
    skuList() {
      return this.topic.productList.map(item => {
        return item.sku.skuId;
      });
    },
    customStyle() {
      // 管理系统设置的背景色 > banner图片的颜色 > 默认值
      const bgColor = op(this.topic).get("banner.bgColor")
      const bgStyle = bgColor ? { background: bgColor } : null 
      
      const defaultStyle = { background: '#FFF7E6' }

      this.isShowBannerImgColor = !bgStyle && this.topicBanner
      if(bgStyle) {
        return bgStyle
      } else {
        return defaultStyle
      }
    },
  },
  methods: {
    bannerJump() {
      this.$router.push(resolveActionPath(op(this.topic).get("banner.action")));
    },
    toMore() {
      this.$router.push(resolveActionPath(op(this.topic).get("action")));
    },
    toProductDetail(href) {
      this.$router.push({path: href.path});
    }
  },
  components: {
    icon,
    price,
    lazyImg,
    isSoldout
  }
};
</script>

